import React, { Component } from "react";

import { CTooltip, CPopover, CCol, CCardHeader, CBadge } from "@coreui/react";
import { withRouter } from "react-router-dom";

import "./styles.css";

class Students extends Component {
  constructor(props) {
    super(props);

    this.state = {
      studentsList: this.props.studentsList
    };
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    if (nextProps.studentsList !== prevState.studentsList) {
      return {
        studentsList: nextProps.studentsList
      };
    }

    return null;
  }

  showInfo(user) {
    // document.getElementsByClassName(user.id + '_' + user.name)[0].style.display = 'block';
  }

  hideInfo(user) {
    // document.getElementsByClassName(user.id + '_' + user.name)[0].style.display = 'none';
  }

  render() {
    return (
      <div className="row">
        {this.state.studentsList.map((item, index) => (
          <React.Fragment key={index}>
            {[7, 8, 9].includes(item.role_id) ? (
              <CCol xs="4" lg="3">
                {item.execution_items ? (
                  <div
                    className={`card bg-${item.color} text-white`}
                    style={{ backgroundColor: item.color }}
                    onMouseEnter={() => this.showInfo(item)}
                    onMouseLeave={() => this.hideInfo(item)}
                  >
                    <div className="card-body p-2 d-flex flex-column align-items-center">
                      <div className="position-relative">
                        <img
                          src={item.profileImage}
                          className="m-2 rounded-circle"
                          style={{ width: "50px", height: "50px" }}
                        />
                        <CPopover
                          header="Informações"
                          content={
                            <>
                              {this.props.activityItems.map(activityItem => (
                                <div key={activityItem.id}>
                                  <strong>{activityItem.title}: </strong>{" "}
                                  {(() => {
                                    const execution = item.execution_items.find(
                                      executionItem =>
                                        executionItem.item_id ===
                                        activityItem.id
                                    );

                                    if (execution) {
                                      return execution.completion_percentage !==
                                        100
                                        ? "A fazer"
                                        : execution.final_grade !== null
                                        ? `${execution.final_grade}`
                                        : "Concluído";
                                    }

                                    return "A fazer";
                                  })()}
                                </div>
                              ))}
                            </>
                          }
                          placement="right"
                        >
                          <div
                            className="position-absolute cursor bg-white rounded-circle p-1"
                            style={{
                              right: "4px",
                              bottom: "4px",
                              lineHeight: 1
                            }}
                          >
                            <i
                              className="fa fa-info text-primary text-center"
                              style={{
                                width: "14px",
                                height: "14px",
                                fontSize: "14px"
                              }}
                            ></i>
                          </div>
                        </CPopover>
                      </div>
                      <div className="h6 text-ellipsis text-center m-2 mw-100 d-flex align-items-center">
                        <div className="flex-1 text-ellipsis">{item.name}</div>
                        <CBadge
                          color="white"
                          className="bg-white text-primary ml-2"
                        >
                          {(
                            item.execution_items.reduce(
                              (acc, val) =>
                                acc + (val.completion_percentage || 0),
                              0
                            ) / item.items
                          ).toFixed(0)}
                          %
                        </CBadge>
                      </div>
                      {/* <div className="row justify-content-center">
                        <div className="h6">
                          {item.activity}
                        </div>
                      </div> */}
                    </div>
                    <div
                      className="progress"
                      style={{ background: "#fff3", height: "3px" }}
                    >
                      <div
                        className="progress-bar"
                        role="progressbar"
                        style={{
                          width: `${
                            item.execution_items.reduce(
                              (acc, val) =>
                                acc + (val.completion_percentage || 0),
                              0
                            ) / item.items
                          }%`,
                          background: "white"
                        }}
                        aria-valuenow="25"
                        aria-valuemin="0"
                        aria-valuemax="100"
                      ></div>
                    </div>
                    <CCardHeader
                      className="text-center small cursor student-card-footer px-1"
                      onClick={() =>
                        this.props.history.push(
                          `/${
                            this.props.isTrailActivity ? "trail" : "activity"
                          }/do/${
                            this.props.match.params.allocation_id
                          }/correct/${
                            item.execution_items.length
                              ? item.execution_items[0].execution_id
                              : 0
                          }`
                        )
                      }
                    >
                      Histórico
                    </CCardHeader>
                  </div>
                ) : (
                  <CTooltip content={item.name}>
                    <div
                      className={`card bg-${item.color} text-white`}
                      style={{ backgroundColor: item.color, cursor: "pointer" }}
                      onMouseEnter={() => this.showInfo(item)}
                      onMouseLeave={() => this.hideInfo(item)}
                      onClick={() =>
                        this.props.onSelect
                          ? this.props.onSelect(item.id)
                          : null
                      }
                    >
                      <div className="card-body p-2">
                        <div className="student-live-image mb-2 rounded-circle">
                          <img
                            src={item.profileImage}
                            className="img img-responsive full-width p-2"
                          />
                        </div>
                        <div className="h6 text-ellipsis text-center m-0">
                          {item.name}
                        </div>
                        {/* <div className="row justify-content-center">
                          <div className="h6">
                            {item.activity}
                          </div>
                        </div> */}
                      </div>
                    </div>
                  </CTooltip>
                )}
              </CCol>
            ) : null}
          </React.Fragment>
        ))}
      </div>
    );
  }
}

export default withRouter(Students);
